<template functional>
  <Badge
    :color="$options.methods.getColor(props.level)"
    :rounded="true"
    size="large"
    :indicator="true"
    >{{ props.level || 'Beginner' }}</Badge
  >
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      required: true,
    },
  },
  methods: {
    getColor(level) {
      return (
        {
          Beginner: 'cyan',
          Intermediate: 'yellow',
          Advanced: 'purple',
        }[level] || 'cyan'
      )
    },
  },
}
</script>
